const isBoolean = value => typeof value === "boolean";

export const getConnection = t => {
  const data =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  const saveData = isBoolean(data?.saveData)
    ? data.saveData
      ? t("global.yes")
      : t("global.no")
    : "-";

  return [
    { id: "downlink", description: data?.downlink || "-" },
    { id: "effectiveType", description: data?.effectiveType || "-" },
    { id: "rtt", description: data?.rtt || "-" },
    { id: "saveData", description: saveData },
  ];
};
